import React, { Component } from "react";
import ReactTable from "react-table";
import {
    Grid,
    Typography,
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Checkbox,
    FormControlLabel
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import * as docApi from "../../../../api/documents";

class DocTypes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            formData: {
                id: null,
                name: "",
                active: true
            },
            confirmDeleteOpen: false,
            itemToDelete: null
        };
    }

    componentDidMount = async () => {
        await this.loadData();
    };

    loadData = async () => {
        const data = await docApi.getDocumentGroupTypes();
        this.setState({ data: data.data.result });
    };

    handleRowClick = (row) => {
        //console.log(row);
        this.setState({
            formData: {
                id: row.original.id,
                name: row.original.name,
                active: row.original.active
            }
        });
    };

    handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: type === "checkbox" ? checked : value
            }
        });
    };

    handleSubmit = async () => {
        const { id, name, active } = this.state.formData;

        if (!name.trim()) return;

        if (id != null) {
            await docApi.updateDocumentGroupType({ id, name, active });
        } else {
            await docApi.insertDocumentGroupType({ name, active });
        }

        await this.loadData();
        this.setState({ formData: { id: null, name: "", active: true } });
    };

    handleOpenDelete = (item) => {
        this.setState({ confirmDeleteOpen: true, itemToDelete: item });
    };

    handleCloseDelete = () => {
        this.setState({ confirmDeleteOpen: false, itemToDelete: null });
    };

    handleClear = () => {
        this.setState({
            formData: {
                id: null,
                name: "",
                active: true
            }
        });
    };

    handleConfirmDelete = async () => {
        const { itemToDelete } = this.state;
        if (itemToDelete) {
            await docApi.deleteDocumentGroupType(itemToDelete);
            await this.loadData();
        }
        this.handleCloseDelete();
    };

    render() {
        const { formData, confirmDeleteOpen } = this.state;
        //console.log(this);
        const columns = [
            {
                Header: "Id",
                accessor: "id",
                width: 90,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }}>
                        {row.original.id}
                    </div>
                )
            },
            {
                Header: "Document Type",
                accessor: "name",
                width: 200,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }}>
                        {row.original.name}
                    </div>
                )
            },
            {
                Header: "Active",
                accessor: "active",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }}>
                        {row.original.active ? "Yes" : "No"}
                    </div>
                )
            },
            {
                Header: "In Use",
                accessor: "inUse",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }}>
                        {row.original.inUse ? "Yes" : "No"}
                    </div>
                )
            },
            {
                Header: "",
                width: 50,
                Cell: row => (
                    <div style={{ textAlign: "center" }}>
                        <IconButton
                            aria-label="delete"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.handleOpenDelete(row.original);
                            }}
                            disabled={row.original.inUse}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                )
            }
        ];

        return (
            <>
                <Typography variant="h6" align="center">
                    Document Types
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <ReactTable
                            data={this.state.data}
                            minRows={0}
                            columns={columns}
                            defaultPageSize={10}
                            className="-striped -highlight tableWrapper"
                            getTrProps={(state, rowInfo) => ({
                                onClick: () => rowInfo && this.handleRowClick(rowInfo)
                            })}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1">
                            {formData.id ? "Edit Document Type" : "Add Document Type"}
                        </Typography>
                        <form noValidate autoComplete="off">
                            <TextField
                                label="Name"
                                name="name"
                                fullWidth
                                value={formData.name}
                                onChange={this.handleChange}
                                margin="normal"
                                disabled={formData.id == 0}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formData.active}
                                        onChange={this.handleChange}
                                        name="active"
                                        color="primary"
                                        disabled={formData.id == 0}
                                    />
                                }
                                label="Active"
                            />
                            <div style={{ marginTop: 12 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleSubmit}
                                    disabled={formData.id == 0}
                                >
                                    {formData.id != null ? "Update" : "Add"}
                                </Button>
                                &nbsp;
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleClear}
                                >
                                    Clear
                                </Button>
                            </div>
                        </form>
                    </Grid>
                </Grid>

                {/* Delete Confirmation Dialog */}
                <Dialog
                    open={confirmDeleteOpen}
                    onClose={this.handleCloseDelete}
                >
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this Document Type?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseDelete} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleConfirmDelete} color="secondary">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default DocTypes;
